export const alertLabels = {
  alertDate: "Alert Date",
  alertType: "Alert Type",
  patientName: "Patient Name"
};
